export default __webpack_public_path__ + "static/media/LockGreenMweb.12f62f33.svg";